/*
 * @Author: jianfanfan 1217572833@qq.com
 * @Date: 2022-12-03 13:56:48
 * @LastEditors: jianfanfan 1217572833@qq.com
 * @LastEditTime: 2025-04-15 09:51:51
 * @FilePath: \pc-chitengmall\src\tools\regexp.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const regphone: RegExp = /^1(3|4|5|6|7|8|9)\d{9}$/; // 验证手机号码

const regpassword: RegExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/; // 验证注册登录密码

const taxnumber: RegExp = /^[A-Z0-9]{16}$|^[A-Z0-9]{18}$/; // 验证纳税人识别号16、19位

const banknumber: RegExp = /^([1-9]{1})(\d{15,18})$/; // 验证银行卡号

const bankname: RegExp = /^[\u4e00-\u9fa5](银行)$/; // 验证开户行(只能为中文已银行结尾);

const regemail: RegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,10})$/; // 验证邮箱

export const isValidPhone = (phone: string): boolean => regphone.test(phone);

export const isValidPassword = (password: string): boolean => regphone.test(password);

export const isValidTax = (number: string): boolean => taxnumber.test(number);

export const isValidBank = (number: string): boolean => banknumber.test(number);

export const isValidBankName = (name: string): boolean => bankname.test(name);

// 验证密码8到20位字母加数字
export const validatePassWord = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error('请输入密码'));
  } else if (!regpassword.test(value)) {
    callback(new Error('请输入正确的6到20位密码'));
  } else {
    callback();
  }
};

// 验证手机号码
export const validateTelPhone = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error('请输入电话号码'));
  } else if (!regphone.test(value)) {
    callback(new Error('请输入正确的11位手机号码'));
  } else {
    callback();
  }
};
// 验证纳税人识别号
export const validateTaxNumber = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error('请输入纳税人识别号'));
  } else if (!taxnumber.test(value)) {
    callback(new Error('请填写正确的纳税人识别号(16或者18位)'));
  } else {
    callback();
  }
};
// 验证银行卡号
export const validateBankNumber = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error('请输入银行卡号'));
  } else if (!banknumber.test(value)) {
    callback(new Error('请填写正确的银行账号(16-19位)'));
  } else {
    callback();
  }
};
// 验证银行名称
export const validateBankName = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error('请输入开户行'));
  } else if (!bankname.test(value)) {
    callback(new Error('请填写正确的开户行'));
  } else {
    callback();
  }
};
// 验证邮箱
export const validateEmail = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error('请输入邮箱'));
  } else if (!regemail.test(value)) {
    callback(new Error('请输入正确的邮箱'));
  } else {
    callback();
  }
};
